import { useEffect } from 'react';

/**
 * Refetches every running Home query when the document becomes visible again, so a tab left in
 * the background (where polls are skipped) shows the day as it is the moment it is looked at.
 * The caller memoizes the refetcher list.
 */
export function useRefetchOnVisible(refetchers: ReadonlyArray<() => void>): void {
  useEffect(() => {
    const onVisibilityChange = () => {
      if (!document.hidden) refetchers.forEach(refetch => refetch());
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => document.removeEventListener('visibilitychange', onVisibilityChange);
  }, [refetchers]);
}
